import React from 'react';
import { cn } from '../../lib/utils';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCircle, FiAlertCircle, FiCheckCircle } = FiIcons;

const StatusBadge = ({ status = 'normal', label, className }) => {
  const configs = {
    critical: { bg: 'bg-red-50', text: 'text-red-600', border: 'border-red-100', icon: FiAlertCircle },
    high: { bg: 'bg-orange-50', text: 'text-orange-600', border: 'border-orange-100', icon: FiAlertCircle },
    normal: { bg: 'bg-emerald-50', text: 'text-emerald-600', border: 'border-emerald-100', icon: FiCheckCircle },
    info: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-100', icon: FiCircle }
  };

  const config = configs[status] || configs.normal;

  return (
    <div className={cn(
      "px-3 py-1.5 rounded-xl border text-[10px] font-black uppercase tracking-widest flex items-center space-x-2 w-fit",
      config.bg, config.text, config.border, className
    )}>
      <SafeIcon icon={config.icon} className="text-xs" />
      <span>{label || status}</span>
    </div>
  );
};

export default StatusBadge;